<div [ngClass]="{'tdo-calender-view-day': selectedViewOption=='1' || selectedViewOption=='2', 'tdo-calender-view-week': selectedViewOption=='3' || selectedViewOption=='4', 'tdo-calender-view-month': selectedViewOption=='5',}" data-cy="scheduler-container">
<table class="sch-table" data-cy="scheduler-header-table">
  <tr class="sch-table-row">
    <td class="sch-table-cell sch-table-cell-date" data-cy="scheduler-date-cell">
      <dx-date-box style="margin-left: 65px;margin-right: 65px; height: 26px" data-cy="scheduler-date"
        type="date"
        [value]="tdoCurrentDate"
        (onValueChanged)="onDateChange($event)">
      >
      </dx-date-box>
    </td>
    <td rowspan="2" class="sch-table-cell sch-table-cell-loc" data-cy="scheduler-locations-cell">
      Locations:
      <dx-tag-box
        [dataSource]="praticeLocations"
        valueExpr="LOCID"
        displayExpr="Name"
        [(value)]="selectedLocationsIDs"
        [showSelectionControls]="true"
        applyValueMode="useButtons"
        [multiline]="false"
        tagTemplate="tagTemplate"
        (onClosed)="onLocationClose($event)"
        data-cy="scheduler-locations-tagbox"
      >

        <div *dxTemplate="let data of 'tagTemplate'" data-cy="scheduler-location-tag">
          <div class="tagStyle">
            <span data-cy="scheduler-location-tag-name"> {{ data.Name }}({{data.LocationShortName}})   </span>
            <mat-icon class="tagRemoveButton" (click)="removeLOCTag(data)" data-cy="scheduler-location-tag-remove">cancel</mat-icon>
          </div>
        </div>

      </dx-tag-box>
    </td>
    <td rowspan="2" class="sch-table-cell sch-table-cell-op-filtr" data-cy="scheduler-operatories-cell">
      Operatories to show:

      <dx-tag-box
        [dataSource]="practiceOperatoriesShow"
        valueExpr="OperatoryId"
        displayExpr= "LocAndOpName"
        [multiline]="false"
        [showSelectionControls]="true"
        applyValueMode="useButtons"
        [(value)]="practiceOperatoriesShowFilterIDs"
        tagTemplate="tagTemplateOrg"
        (onClosed)="onpracticeOperatoriesFilterChange($event)"
        data-cy="scheduler-operatories-tagbox"
      >

        <div *dxTemplate="let data of 'tagTemplateOrg'" data-cy="scheduler-operatory-tag">
          <div class="tagStyle">
            <span data-cy="scheduler-operatory-tag-name">{{data.LocationShortName}}-{{ data.OperatoryName }}   </span>
            <mat-icon class="tagRemoveButton" (click)="removeOpTag(data)" data-cy="scheduler-operatory-tag-remove">cancel</mat-icon>
          </div>
        </div>

      </dx-tag-box>

    </td>
    <td rowspan="2" class="sch-table-cell sch-table-cell-views" data-cy="scheduler-views-cell">

      <button mat-raised-button style="width: 90%" [matMenuTriggerFor]="menu" data-cy="scheduler-view-button">{{ viewTypeButtonCaption }}</button>
      <mat-menu #menu="matMenu" data-cy="scheduler-view-menu">
        <button mat-menu-item (click)="btnViewTypeClicked($event,'1')" data-cy="scheduler-view-std">Standard View</button>
        <button mat-menu-item (click)="btnViewTypeClicked($event,'2')" data-cy="scheduler-view-day">Day Detail View</button>
        <button mat-menu-item (click)="btnViewTypeClicked($event,'3')" data-cy="scheduler-view-week">Week View</button>
        <button mat-menu-item (click)="btnViewTypeClicked($event,'4')" data-cy="scheduler-view-work">Work Week View</button>
        <button mat-menu-item (click)="btnViewTypeClicked($event,'5')" data-cy="scheduler-month">Month View</button>
      </mat-menu>

    </td>
    <td rowspan="2" data-cy="scheduler-waitlist-cell">

      <div style="float: right; padding-right: 10px; width: 200px" data-cy="scheduler-waitlist-container">
        <div style="display: flex;  justify-content: center;  align-items: center;" data-cy="scheduler-waitlist-button-container">
          <dx-button
            text="Wait List"
            icon="bulletlist"
            (onClick)="onOpenWaitListComponent()"
            data-cy="scheduler-waitlist-button"
          >
          </dx-button>
        </div>
        <div *ngIf="this.globals.RescheduleAppointmentRequest" style="display: flex;  justify-content: center;  align-items: center;" data-cy="scheduler-reschedule-container">

         <span style="font-size:x-small" data-cy="scheduler-reschedule-name">Reschedule: {{this.globals.RescheduleAppointmentRequest.Patient_FullName}}</span>
         <dx-button
           icon="clear"
           type="success"
           (onClick)="onClickClearReschedule()"
           data-cy="scheduler-reschedule-clear"></dx-button>

        </div>
      </div>

    </td>

  </tr>

  <tr class="sch-table-row">
    <td class="sch-table-cell sch-table-cell-date" data-cy="scheduler-navigation-cell">

      <div data-cy="scheduler-navigation-container">
        <mat-icon class="sch-cal-nav" (click)="goToPreviousMonth()" matTooltip='Previous Month' data-cy="scheduler-date-prev-month">skip_previous</mat-icon>
        <mat-icon class="sch-cal-nav" (click)="goToPreviousWeek()" matTooltip='Previous Week' data-cy="scheduler-date-prev-week">keyboard_double_arrow_left</mat-icon>
        <mat-icon class="sch-cal-nav" (click)="goToPreviousDay()" matTooltip='Previous Day' data-cy="scheduler-date-prev-day">arrow_back_ios</mat-icon>

      <button mat-button color="primary" style="margin-top: -15px" (click)="goToToday()" matTooltip="Go To Today's Date" data-cy="scheduler-date-today">
        Today
      </button>

        <mat-icon class="sch-cal-nav" (click)="goToNextDay()" matTooltip='Next Day' data-cy="scheduler-date-next-day">arrow_forward_ios</mat-icon>
        <mat-icon class="sch-cal-nav" (click)="goToNextWeek()" matTooltip='Next Week' data-cy="scheduler-date-next-week">keyboard_double_arrow_right</mat-icon>
        <mat-icon class="sch-cal-nav" (click)="goToNextMonth()" matTooltip='Next Month' data-cy="scheduler-date-next-month">skip_next</mat-icon>
      </div>
    </td>

  </tr>
</table>


<dx-scheduler #tdoScheduler
              [showAllDayPanel]="false"
              [dataSource]="appotmentsInRangeToShow"
              [groups]="['OperatoryId']"
              resourceCellTemplate="operatoryTemplate"
              [views]="['day', 'week', 'workWeek', 'month']"
              [currentView]="viewType"
              [startDayHour]="visibleStartHour" [endDayHour]="visibleEndHour" [cellDuration]="cellDuration"
              [showCurrentTimeIndicator]='true'
              [currentDate]="tdoCurrentDate"
              [crossScrollingEnabled]="true"
              [height]="'calc(100vh - 50px)'" [width]="'100%'"
              startDateExpr="zstartDate"
              endDateExpr="zendDate"
              appointmentTemplate="TDOAppointmentTemplate"
              appointmentTooltipTemplate="TDOAppointmentTooltip_Template"
              (onAppointmentDblClick)="overrideDefaultPopup($event)"
              (mouseup)="onMouseUp($event)" (onCellClick)="onCellClick($event);"
              (onAppointmentClick)="onAppointmentClick($event)"
              (onOptionChanged)="onOptionChanged($event)"
              (onContentReady)="onContentReadyTDOScheduler($event)"
              (onAppointmentUpdated)="onAppointmentUpdated($event)"
              (onAppointmentContextMenu)="onAppointmentContext($event)"
              data-cy="scheduler-component"
              >


    <dxo-editing [allowAdding]="false"></dxo-editing>

    <dxi-resource fieldExpr="OperatoryId"
                  valueExpr="OperatoryId"
                  displayExpr="OperatoryName"
                  [dataSource]="practiceOperatoriesShowFilter"
                  data-cy="scheduler-resource"
    >
    </dxi-resource>

  <!--Templates-->

  <div *dxTemplate="let op of 'operatoryTemplate'" data-cy="scheduler-operatory-template">
    <div [ngStyle]="{'backgroundColor': op.data.color != null ? op.data.color : 'var(--tdo-primary-accent'}"
         [style.width.pct]="100" data-cy="scheduler-operatory">

      <div class="calendar-column-header-text" style="color: white; font-size: 10px;" data-cy="scheduler-operatory-header">
        <div [matTooltip]="op.data.OperatoryDescription" data-cy="scheduler-operatory-name">{{op.data.LocAndOpName}}</div>
      </div>
    </div>
   </div>

  <div *dxTemplate="let app of 'TDOAppointmentTooltip_Template'" [innerHTML]="app.appointmentData.LabelTooltip??'loading info...'" data-cy="scheduler-appointment-tooltip"></div>

  <div *dxTemplate="let app of 'TDOAppointmentTemplate'"
       [style.background-color]="app.appointmentData?.ProviderDoctor_BackColor" [style.color]="app.appointmentData?.ProviderDoctor_ForeColor"
       [style.padding-top]="0" [style.padding-left]="0" [style.padding-right]="0"
       data-cy="scheduler-appointment"
  >

    <div
      style="pointer-events: none; background-color: var(--tdo-primary); color: white; position: relative; width: 100%;"
      *ngIf="app.appointmentData.isReservation"
      data-cy="scheduler-appointment-reserved"
    >
      <div
        style="width: 100%; text-align: center; font-weight: 500;"
        data-cy="scheduler-appointment-reserved-text"
      >
        RESERVED
      </div>
    </div>

    <div style="background-color: orange; pointer-events: none; color: white; position: relative; width: 100%;"
      *ngIf="isBlockAppt(app.appointmentData)"
      data-cy="scheduler-appointment-blocked"
    >

      <div style="width: 100%; text-align: center; font-weight: 500;" data-cy="scheduler-appointment-blocked-header">
        <div *ngIf="app.appointmentData.enumApptTypeId ==='00000071-0000-0000-0000-000000000005'" data-cy="scheduler-appointment-blocked-out">
          BLOCKED OUT
        </div>

        <div *ngIf="app.appointmentData.enumApptTypeId =='00000071-0000-0000-0000-000000000006'" data-cy="scheduler-appointment-blocked-in">
          BLOCKED IN
        </div>
      </div>
      <div style="margin-top: 5px;" data-cy="scheduler-appointment-blocked-details">
      <div style="width: 100%; overflow-wrap: break-word; word-break: break-all;" data-cy="scheduler-appointment-blocked-subject">
        {{app.appointmentData.Subject}}
      </div>
      <div style="width: 100%; overflow-wrap: break-word; word-break: break-all;" data-cy="scheduler-appointment-blocked-description">
        {{app.appointmentData.Description}}
      </div>
      </div>
    </div>

    <div *ngIf="!isBlockAppt(app.appointmentData) && app.appointmentData.isReservation===false" style="font-size: x-small; margin: 0; padding: 0" data-cy="scheduler-appointment-normal">

      <div class="appoitment-layout-row" data-cy="scheduler-appointment-row">

        <div class="appoitment-layout-column appoitment-layout-right"
             [style.background-color]="app.appointmentData?.AppoitmentStatus_BackColor" [style.color]="app.appointmentData?.AppoitmentStatus_ForeColor"
             data-cy="scheduler-appointment-right"
        >
          <div (click)="onOpenMedicalInformationFormDialog(app.appointmentData);"
               matTooltip="Appointment Medical Information"
               data-cy="scheduler-appointment-medical-info"
          >
            <mat-icon style="width: 22px; height: 22px; color: #00a200" data-cy="scheduler-appointment-medical-icon">medical_information</mat-icon>
          </div>
        </div>
        <div class="appoitment-layout-column appoitment-layout-left" data-cy="scheduler-appointment-left">
          <div class="header-class"
               [style.background-color]="app.appointmentData?.AppoitmentType_BackColor" [style.color]="app.appointmentData?.AppoitmentType_ForeColor"
               data-cy="scheduler-appointment-header"
          >Flags:
             <dev *ngFor="let i of loadPatientFlags(app.appointmentData.PatientFlags)"  >
              <img class="appoitment_flag" [src]="i.IconIDSVG" [matTooltip]="i.ItemDisplayValue" [alt]="i.ItemDisplayValue"/>
            </dev>
            <dev *ngFor="let i of loadAppoitmentsFlags(app.appointmentData.AppointmentFlags)"  >
              <img class="appoitment_flag" [src]="i.IconIDSVG" [matTooltip]="i.ItemDisplayValue" [alt]="i.ItemDisplayValue"/>
            </dev>
          </div>
          <div class="left-content-class" [innerHTML]="app.appointmentData.LabelLine1??'loading info...'"></div>
        </div>
      </div>
    </div>
  </div>
  <div *dxTemplate="let dataCell of 'dataCellTemplate'" >
    -
  </div>
</dx-scheduler>
<dx-context-menu [dataSource]="rightClickAppointmentOptions" [width]="200" target=".dx-scheduler-appointment"
                 (onItemClick)="ctxMenuItemClickApp($event)" [(visible)]="isAppContextMenuVisible">
</dx-context-menu>
<dx-context-menu [dataSource]="rightClickScheduleOptions" [width]="200" target=".dx-scheduler-date-table-cell"
                 (onItemClick)="ctxMenuItemClickCell($event)" [(visible)]="isCellContextMenuVisible">
</dx-context-menu>

<template >
     <div style="background-color: #d0f4fe  ;  width:1400px; height: 45px ; justify-content: left;" *ngIf="showTemplate">test
     </div>
</template>
</div>